export const SCHOOL_GROUPS = [3, 4, 5, 6, 7, 8] as const;

export type SchoolGroup = (typeof SCHOOL_GROUPS)[number];

export function isSchoolGroup(value: unknown): value is SchoolGroup {
  return typeof value === 'number' && (SCHOOL_GROUPS as readonly number[]).includes(value);
}
